import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'twyne-new.ui';

class SelectValidation extends React.Component {
  render() {
    const { setValue, onChange, getValue, name, loadOptions, placeholder, isRequired, isValid, isPristine } = this.props;
    const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid form-control border-0 p-0' : '';

    return <React.Fragment>
      <Select
        name={name}
        value={getValue()}
        onChange={option => { setValue(option ? option.value : null); onChange && onChange(option ? option.value : null); }}
        loadOptions={loadOptions}
        placeholder={placeholder}
        className={isInvalidClass}
        async
      />
      <span className="invalid-feedback">
        {isRequired() && !getValue() && ' Field required'}
      </span>
    </React.Fragment>
  }
}

SelectValidation.propTypes = {
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  name: PropTypes.string,
  loadOptions: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string
};

export default withFormsy(SelectValidation);
